import { column, edge, flow, makeFlow, node } from "../builders";
import type { TemplateDef } from "../types";

const seq = column("f1", 100, 70, 92, [
  ["t1", "auto-trigger", "New lead created", { props: { triggerType: "Contact Created", event: "Lead ad or site form" } }],
  ["s1", "auto-sms", "Text back in 60 seconds", { props: { message: "Hi {{contact.first_name}}, it's {{user.first_name}} from ___ — got your enquiry, is now a good time for a quick call?" } }],
  ["nt", "auto-notify", "Alert the rep", { props: { channel: "sms", message: "New lead: {{contact.full_name}} — call now" } }],
  ["k1", "auto-task", "Call within 5 minutes", { props: { assignee: "Lead owner", due: "+5 minutes" } }],
  ["w1", "auto-wait", "Wait 5 minutes", { props: { duration: "5", unit: "minutes" } }],
  ["c1", "auto-condition", "Did we reach them?", { props: { condition: "Has tag 'connected'" } }],
  ["e1", "auto-email", "Pick a time instead", { props: { subject: "Tried to call — here's my calendar" } }],
  ["p1", "auto-pipeline", "Move to Contacted", { props: { pipeline: "Sales", stage: "Contacted" } }],
]);

const def: TemplateDef = {
  slug: "speed-to-lead-callback",
  name: "Speed-to-Lead Callback",
  category: "Lead gen",
  tagline:
    "Text back in 60 seconds, alert the rep, and book the call before the lead cools.",
  description:
    "A free speed-to-lead template: the moment a lead ad or web form creates a contact, an SMS goes out, the rep gets pinged, a 5-minute call task appears, and a calendar link follows if nobody picks up. Clone it into FrazzleCRM and every step runs for real.",
  whatsInside: [
    "Instant text-back so the lead hears from you first",
    "Internal SMS alert plus a 5-minute call task for the owner",
    "A reached-them? branch that sends a booking link when the call misses",
    "Pipeline stage move so the CRM reflects what actually happened",
  ],
  flow: makeFlow(
    [
      node("src1", "traffic-facebook", "Facebook Lead Ads", 40, 60, { props: { campaign: "Lead gen — instant form" } }),
      node("src2", "traffic-google", "Google Ads", 40, 220, { props: { campaign: "High-intent search" } }),
      node("fm", "page-popup", "Enquiry form", 360, 140, { props: { trigger: "Instant form / site form" } }),
      flow("f1", "5-Minute Callback", 680, 40, 420, 856),
      ...seq.nodes,
      node("bk", "page-booking", "Book a call", 1200, 340, { props: { duration: "20 min" } }),
      node("out", "outcome-appointment", "Appointment booked", 1520, 340),
      node("n1", "util-note", "Why 5 minutes", 360, 340, {
        notes:
          "Response time is the single biggest lever on lead-to-call rate. The text buys you the minutes the call task needs — send it before a human is involved at all.",
      }),
    ],
    [
      edge("src1", "fm"),
      edge("src2", "fm"),
      edge("fm", "f1"),
      ...seq.edges,
      edge("f1", "bk"),
      edge("bk", "out"),
    ]
  ),
};

export default def;
